/** Clerk user ids allowed to see the dashboard besides super admins. */
const ALLOWED_USER_IDS = new Set(["user_3JpC3rS62KTWcK5P8giM4Cl04ps"]);

/** Super admins and explicitly allow-listed users can open the launch dashboard. */
export const canAccessLaunchSimulator = (
  user:
    { id: string; publicMetadata?: Record<string, unknown> } | null | undefined
): boolean =>
  !!user &&
  (user.publicMetadata?.admin === true || ALLOWED_USER_IDS.has(user.id));
